import React from 'react';

const BOMForm = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center p-4">
      <div className="w-full md:w-1/2 p-2">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Select Supplier</label>
          <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
            <option value="">Select</option>
            <option value="">Waree</option>
            <option value="">Vikram</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Select Binning</label>
          <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
            <option value="">Select</option>
            <option value="">14.2 - 14.4</option>
            <option value="">14.4 - 14.6</option>
            <option value="">14.6 - above</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Module Wattage</label>
          <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
            <option value="">Select</option>
            <option value="">Module Wattage 1</option>
            <option value="">Module Wattage 2</option>
          </select>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-2 mb-[6rem]">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Storage Location</label>
          <input type="text" className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue" placeholder="Enter Storage Location"/>
        </div>
        <div className="mb-4 flex justify-center">
          <button className="bg-customBlue text-white p-2 rounded-md">Submit</button>
        </div>
      </div>
    </div>
  );
};

export default BOMForm;
